import React, { useEffect, useState } from "react";
import axios from "axios";
import AccountChequeFormModal from "./AccountChequeForm";
import CustomNavbar from "../../CustomPermissions/CustomNavbar";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../../config/api";

const AccountChequeList = () => {
  const [cheques, setCheques] = useState([]);
  const [editingCheque, setEditingCheque] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Fetch all cheque records
  useEffect(() => {
    const fetchCheques = async () => {
      try {
        const accessToken = localStorage.getItem("access_token");
        const response = await axios.get(
          getApiUrl("/PartnerFiles/api/cheques/"),
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );
        setCheques(response.data);
      } catch (error) {
        console.error("Error fetching cheques:", error);
      }
    };
    fetchCheques();
  }, []);

  // Handle cheque deletion
  const handleDelete = async (id) => {
    try {
      const accessToken = localStorage.getItem("access_token");
      await axios.delete(
        getApiUrl(`/PartnerFiles/api/cheques/${id}/`),
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      setCheques(cheques.filter((cheque) => cheque.id !== id));
    } catch (error) {
      console.error("Error deleting cheque:", error);
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <CustomNavbar />

      <div className="p-3 bg-gradient-to-br from-blue-50 to-blue-200 min-h-screen" style={{ width: "100vw" }}>
        {/* Title */}
        <h2 className="text-3xl font-bold text-blue-800 mb-3 text-center">
          Cheque Records Management
        </h2>

        {/* Buttons to Open Modal */}
        <div className="flex justify-center mb-4">
          <button
            onClick={() => {
              setEditingCheque(null); // Reset editing state for new creation
              setIsModalOpen(true); // Open modal
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition duration-200"
          >
            Create New Cheque
          </button>
        </div>

        {/* Table for listing cheques */}
        <div className="overflow-x-auto rounded-lg shadow-md">
          <table className="min-w-full bg-white border border-blue-300 divide-y divide-blue-300"  style={{ width: "100%" }}>
            <thead className="bg-blue-100">
              <tr className="bg-blue-500">
                <th className="px-4 py-3 text-left text-sm font-semibold uppercase tracking-wider">
                  ID
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold uppercase tracking-wider">
                  Account ID
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold uppercase tracking-wider">
                  Cheque Number Start
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold uppercase tracking-wider">
                  Cheque Number End
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-blue-300">
              {cheques.map((cheque) => (
                <tr
                  key={cheque.id}
                  className="hover:bg-blue-50 transition duration-200"
                >
                  <td className="px-4 py-3 text-sm text-blue-900">
                    {cheque.id}
                  </td>
                  <td className="px-4 py-3 text-sm text-blue-900">
                    {cheque.acc}
                  </td>
                  <td className="px-4 py-3 text-sm text-blue-900">
                    {cheque.cheque_number_start}
                  </td>
                  <td className="px-4 py-3 text-sm text-blue-900">
                    {cheque.cheque_number_end}
                  </td>
                  <td className="px-4 py-3 text-sm text-blue-900 space-x-2">
                    <button
                      onClick={() => {
                        setEditingCheque(cheque); // Set cheque for editing
                        setIsModalOpen(true); // Open modal
                      }}
                      className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition duration-200"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(cheque.id)}
                      className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 transition duration-200"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Modal for Create/Edit Form */}
        {isModalOpen && (
          <AccountChequeFormModal
            cheques={cheques}
            setCheques={setCheques}
            editingCheque={editingCheque}
            onClose={() => setIsModalOpen(false)} // Close modal
          />
        )}
      </div>
    </div>
  );
};

export default AccountChequeList;
